var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrgent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_619_5936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30ZM15 7.5C15.7793 7.5 16.4062 8.12695 16.4062 8.90625V15.4688C16.4062 16.248 15.7793 16.875 15 16.875C14.2207 16.875 13.5938 16.248 13.5938 15.4688V8.90625C13.5938 8.12695 14.2207 7.5 15 7.5ZM13.125 20.625C13.125 20.1277 13.3225 19.6508 13.6742 19.2992C14.0258 18.9475 14.5027 18.75 15 18.75C15.4973 18.75 15.9742 18.9475 16.3258 19.2992C16.6775 19.6508 16.875 20.1277 16.875 20.625C16.875 21.1223 16.6775 21.5992 16.3258 21.9508C15.9742 22.3025 15.4973 22.5 15 22.5C14.5027 22.5 14.0258 22.3025 13.6742 21.9508C13.3225 21.5992 13.125 21.1223 13.125 20.625Z",
    fill: "#F33E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_619_5936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgent);
export default __webpack_public_path__ + "static/media/urgent.a84b194c11f7eab888333bb093bd115f.svg";
export { ForwardRef as ReactComponent };